'use client';

import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import useFetch from 'use-http';
import Page from '../Page';
import Loader from '../Loader';

export default function PopularSearches() {
  const history = useHistory();
  const { get: getPopularSearches, request } = useFetch(
    '/UserSearchManagement/popularSearch',
  );
  const [popularSearches, setPopularSearches] = useState([]);
  const [loading, setLoading] = useState(false);

  const groupingCriteria = Object.freeze({
    NONE: 0,
    TYPE: 1,
    GROUP: 2,
    HIERARCHY: 3,
    SPECIALTY: 4,
    COMPLEXSERVICES: 5,
  });

  const holterTypeExternalId = process.env.REACT_APP_HOLTER;

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const result = await getPopularSearches();
      if (!!result && Array.isArray(result)) {
        setPopularSearches(
          result.sort((a, b) => b.numberOdSearches - a.numberOdSearches),
        );
      }
      setLoading(false);
    }

    fetchData();
  }, []);

  const makeUrl = (popularSearch) => {
    if (popularSearch.criteria === groupingCriteria.COMPLEXSERVICES) {
      if (
        popularSearch.serviceTypeExternalId.toString() ===
        holterTypeExternalId.toString()
      )
        return `/services/${popularSearch.categoryId}/${popularSearch.serviceTypeId}`;
      return `/kompleksines-paslaugos?groupId=${popularSearch.serviceTypeExternalId}`;
    }
    if (popularSearch.criteria === groupingCriteria.SPECIALTY)
      return `services/${popularSearch.categoryId}/${popularSearch.serviceTypeId}?specialtyId=${popularSearch.specialtyId}`;
    if (popularSearch.criteria === groupingCriteria.HIERARCHY)
      return `services/${popularSearch.categoryId}/${popularSearch.serviceTypeId}?hierarchyId=${popularSearch.hierarchyId}`;
    if (popularSearch.criteria === groupingCriteria.GROUP)
      return `services/${popularSearch.categoryId}/${popularSearch.serviceTypeId}?serviceGroupId=${popularSearch.groupId}`;
    return `services/${popularSearch.categoryId}/${popularSearch.serviceTypeId}/`;
  };

  return (
    <div className="my-4.5 md:p-0 md:mt-6 font-primary">
      <div className="w-full bg-[#E6F2FF] rounded-[20px] p-4 md:p-6">
        <h2 className="text-[#5180CA] text-base md:text-2xl font-semibold mb-3 md:mb-4">
          Populiarios paieškos:
        </h2>
        {loading && (
          <Page>
            <Loader />
          </Page>
        )}

        <div className="flex flex-wrap max-h-[9.9rem] md:max-h-[5rem] overflow-hidden gap-2">
          {popularSearches.map((term, index) => (
            <button
              key={index}
              onClick={() => history.push(makeUrl(term))}
              className="px-2 md:px-3 rounded-full border-primary bg-[#E6F2FF] border-2
            //  hover:bg-[#CCE6FF] 
             text-primary hover:text-secondary hover:border-secondary font-semibold transition-colors cursor-pointer min-h-8
             max-w-full overflow-hidden"
            >
              <span
                className="block truncate whitespace-nowrap text-sm md:text-base"
                title={term.title}
              >
                {term.title}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
